import React, { useEffect, useState } from 'react'
import PostCard from '../components/PostCard';
import { getPost } from '../redux/actions/post';
import { useDispatch, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import { Breadcrumb, Spin, Input } from 'antd';
import { getCategories } from '../redux/actions/category';
import { Helmet } from 'react-helmet-async';
import { SearchOutlined } from '@ant-design/icons';

const { Search } = Input;

export const Posts = () => {
    const { posts } = useSelector((state: any) => state.posts);
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [filteredPosts, setFilteredPosts] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

    useEffect(() => {
        dispatch<any>(getPost());
        dispatch<any>(getCategories());
    }, [dispatch]);

    useEffect(() => {
        const query = searchParams.get('search');
        if (query) {
            setSearchQuery(query);
        }
    }, [searchParams]);

    useEffect(() => {
        if (posts && posts.length > 0) {
            if (searchQuery.trim()) {
                const filtered = posts.filter((post: any) =>
                    post.title?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    post.content?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                    post.excerpt?.toLowerCase().includes(searchQuery.toLowerCase())
                );
                setFilteredPosts(filtered);
            } else {
                setFilteredPosts(posts);
            }
        }
    }, [posts, searchQuery]);

    const handleSearch = (value: string) => {
        setSearchQuery(value);
        if (value.trim()) {
            setSearchParams({ search: value });
        } else {
            setSearchParams({});
        }
    };

    const breadcrumbItems = [
        {
            title: 'Anasayfa',
            href: '/',
        },
        {
            title: 'Blog',
            href: '/blog',
        },
    ];

    return (
        <MainLayout>
            <Helmet>
                <title>Blog | Sakarya Lastik</title>
                <meta name="description" content="Blog sayfası | Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
                <meta name="keywords" content="blog, blog sayfası, blog yazıları" />
                <meta property="og:title" content="Blog | Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
                <meta property="og:description" content="Blog sayfası | Sakarya Lastik - İş makinesi lastikleri, kamyon lastikleri, lastik tamiri ve bakımı konusunda uzman ekibimizle hizmetinizdeyiz. Yüksek kaliteli lastik çözümleri için bizi tercih edin." />
                <meta property="og:type" content="website" />
            </Helmet>
            <div className='flex w-full bg-gray-50 p-3 border rounded-md'>
                <Breadcrumb items={breadcrumbItems} />
            </div>
            <div className='container mx-auto'>
                <div className='flex justify-between items-center my-5'>
                    <h1 className='text-2xl font-bold'>Blog</h1>
                    <Search
                        placeholder="Blog yazılarında ara..."
                        allowClear
                        enterButton={<SearchOutlined />}
                        size="large"
                        value={searchQuery}
                        onChange={(e) => handleSearch(e.target.value)}
                        onSearch={handleSearch}
                        style={{ maxWidth: 400 }}
                    />
                </div>
                {searchQuery && (
                    <div className='mb-4 text-gray-600'>
                        <span className='font-semibold'>{filteredPosts.length}</span> sonuç bulundu
                        {searchQuery && ` "${searchQuery}" için`}
                    </div>
                )}
                <div className='flex flex-wrap gap-3'>
                    {filteredPosts.length > 0 ? filteredPosts?.map((post: any) => (
                        <PostCard key={post._id} post={post} />
                    )) : searchQuery ? (
                        <div className='w-full text-center py-10 text-gray-500'>
                            <SearchOutlined style={{ fontSize: 48 }} />
                            <p className='mt-4'>"{searchQuery}" için sonuç bulunamadı</p>
                        </div>
                    ) : <Spin />}
                </div>
            </div>
        </MainLayout>
    )
}

export default Posts;
